import React, { useState, useEffect } from 'react';
import Article from '../Article/Article';
import { Link } from 'react-router-dom';

const YouTubePartnershipPost = () => {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    fetch('/content/blog/youtube-partnership.md')
      .then(response => response.text())
      .then(text => setMarkdown(text));
  }, []);

  return (
    <Article
      title="Scuttlebutt is now developed with YouTube"
      subtitle="A new partnership that brings YouTube's video commentary into our customer-research pipeline."
      markdown={markdown}
      callToAction={
        <Link to="/book-demo" className="btn btn-primary btn-lg btn-very-wide btn-square">
          Book a Demo
        </Link>
      }
    />
  );
};

export default YouTubePartnershipPost;
